export const ASSESSMENT_BADGE_IN_PROGRESS = 'progress';
export const ASSESSMENT_BADGE_COMPLETED = 'completed';
export const ASSESSMENT_BADGE_EXPIRED = 'expired';
